/**
 * The PropWise logo, served from public/logos/. One path for every component
 * that shows it (the auth card, the sidebar and the terms prompt), so a logo
 * change is a one-line edit. Each caller keeps its own size.
 */
export const BRAND_LOGO = {
  src: '/logos/PropWise Logo Design-01.svg',
  alt: 'PropWise Logo',
} as const;
